import styled from 'styled-components';

export const City = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;

  div:first-child {
    align-items: center;
  }

  div:nth-child(2) {
    margin-left: ${({ theme }) => theme.spacing.km3};
    max-width: 65vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const Circle = styled.div`
  font-size: ${({ theme }) => theme.font.size.m1};
  color: ${({ theme }) => theme.color.text.neutral.weak};
  font-weight: ${({ theme }) => theme.font.weight.bold};
`;

export const Square = styled.div`
  font-size: ${({ theme }) => theme.font.size.m1};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  color: ${({ theme }) => theme.color.text.neutral.weak};
`;
